import axios from 'axios';
import {
  TIMESERIES_LIST_REQUEST,
  TIMESERIES_LIST_SUCCESS,
  TIMESERIES_LIST_FAIL,
  SET_ACTIVE_TIMESCALE,
} from '../constants/TimeSeriesConstants';

export const getAllTimeSeries = () => async (dispatch) => {
  try {
    dispatch({ type: TIMESERIES_LIST_REQUEST });

    const { data } = await axios.get(`https://rich-pulse.vercel.app/api/timeseries`);

    dispatch({
      type: TIMESERIES_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: TIMESERIES_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getStats = (name) => async (dispatch) => {
  try {
    dispatch({ type: TIMESERIES_LIST_REQUEST });

    const { data } = await axios.get(`https://rich-pulse.vercel.app/api/timeseries/${name}`);

    dispatch({
      type: TIMESERIES_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: TIMESERIES_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const setActiveTimescale = (name) => (dispatch) => {
  dispatch({ type: SET_ACTIVE_TIMESCALE, payload: name });
};